/*
 * @Author: your name
 * @Date: 2020-10-15 16:42:46
 * @LastEditTime: 2020-11-02 08:44:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\static\js\state.js
 */

// console.log(localStorage)

var stateType = {
    aiAbstract: true,
    aithank: false,
    isLogin: false,
    userInfo: {},
    mocke: {},
    show_ab_btn: false,
    msg: false,
    cctext: "您该篇论文还未进行过查重"
};

if (localStorage.getItem("token")) {
    stateType.isLogin = true;
    stateType.userInfo = JSON.parse(localStorage.getItem("userinfo"));
}
async function getmock(){
    var mocke =await import('./mocdata') 
    stateType.mocke=mocke.default
}


export default stateType;



// WEBPACK FOOTER //
// ./static/js/state.js